import UserSettings from '@/views/users/UserSettings.vue'

export default {
  path: '/installningar',
  name: 'SettingsHome',
  component: UserSettings
}
